<template>
  <span class="pagination__jump">
    <span v-if="pageLength !== ''">{{ i18n.t('共') + ' ' + pageLength + ' ' + i18n.t('页') }}</span>
    &nbsp;
    <span>
      {{i18n.t('el.pagination.goto')}}
    </span>
    <el-input
      class="pagination__editor is-in-pagination"
      :min="1"
      :max="$parent.internalPageCount"
      :value="userInput !== null ? userInput : $parent.internalCurrentPage"
      type="number"
      :disabled="$parent.disabled"
      :nativeOnKeyup="handleKeyup"
      @input="handleInput"
      @change="handleChange"
    />
    <span>
      {{i18n.t('页')}}
    </span>
    <span
      class="button"
      @click="handleGoPage"
    >
      {{i18n.t('跳转')}}
    </span>
  </span>
</template>

<script>
import i18n from '@/lang'

export default {
  props: {
    pageLength: {
      type: [String, Number],
      default: ''
    }
  },
  data () {
    return {
      i18n,
      userInput: null
    }
  },

  watch: {
    '$parent.internalCurrentPage' () {
      this.userInput = null
    }
  },

  methods: {
    handleKeyup ({ keyCode, target }) {
      // Chrome, Safari, Firefox triggers change event on Enter
      // Hack for IE: https://github.com/ElemeFE/element/issues/11710
      // Drop this method when we no longer supports IE
      if (keyCode === 13) {
        this.handleChange(target.value)
      }
    },
    handleInput (value) {
      this.userInput = value
    },
    handleChange (value) {
      // this.$parent.internalCurrentPage = this.$parent.getValidCurrentPage(value)
      // this.$parent.emitChange()
      // this.userInput = null
    },
    handleGoPage () {
      if (!this.userInput) return
      this.$parent.internalCurrentPage = this.$parent.getValidCurrentPage(this.userInput)
      this.$parent.emitChange()
      this.userInput = null
    }
  }

}
</script>

<style>
</style>
